const clientPortalScreens = [
  {
    id: "portal-landing-desktop",
    kind: "desktop",
    slot: "desktop",
    src: "/images/cooperators/case-studies/client-portal/portal-landing-desktop.webp",
    alt: "Co-operators client portal landing experience on desktop",
    caption: "Client portal landing experience on desktop",
    frame: {
      x: 3,
      y: 4,
      width: 82,
      height: 62,
      rotation: 0,
      zIndex: 1,
      cropX: 50,
      cropY: 0,
    },
  },
  {
    id: "portal-authenticated-desktop",
    kind: "desktop",
    slot: "tertiary",
    src: "/images/cooperators/case-studies/client-portal/portal-authenticated-desktop.webp",
    alt: "Authenticated Co-operators payment experience on desktop",
    caption: "Authenticated payment experience on desktop",
    frame: {
      x: 27,
      y: 31,
      width: 61,
      height: 57,
      rotation: 0,
      zIndex: 2,
      cropX: 50,
      cropY: 0,
    },
  },
  {
    id: "portal-authenticated-mobile",
    kind: "phone",
    slot: "primary",
    src: "/images/cooperators/case-studies/client-portal/portal-authenticated-mobile.webp",
    alt: "Authenticated Co-operators payment experience on mobile",
    caption: "Authenticated payment experience on mobile",
    frame: {
      x: 72,
      y: 24,
      width: 24,
      height: 72,
      rotation: 3,
      zIndex: 4,
      cropX: 50,
      cropY: 0,
    },
  },
];

export default clientPortalScreens;
